// extracted by mini-css-extract-plugin
module.exports = {"wrap":"src/components/Loading/styles__wrap--1uW1_","spinner":"src/components/Loading/styles__spinner--3DxFV"};